import ClientLayout from '@/components/feature/ClientLayout';
import { useClientProject } from '@/hooks/useClientProject';
import { useTranslation } from 'react-i18next';
import ClientChangeOrdersPanel from './ClientChangeOrdersPanel';

export default function ClientChangeOrdersPage() {
  const { t } = useTranslation();
  const { selectedProject, projectId } = useClientProject();

  return (
    <ClientLayout title={t('nav.changeOrders')}>
      <div className="px-4 lg:px-8 pt-5 pb-10">
        {selectedProject && (
          <div className="mb-5 flex items-center gap-2">
            <div className="w-6 h-6 rounded-lg bg-[#E8621A] flex items-center justify-center flex-shrink-0">
              <i className="ri-building-2-line text-white text-[10px]"></i>
            </div>
            <div>
              <span className="text-[#1A1A1A] text-sm font-bold">{selectedProject.project_name}</span>
              {selectedProject.site_address && (
                <span className="text-[#9CA3AF] text-xs ml-2">{selectedProject.site_address}</span>
              )}
            </div>
          </div>
        )}

        <div className="mb-4">
          <h2 className="text-[15px] font-bold text-[#1A1A1A]">{t('nav.changeOrders')}</h2>
          <p className="text-[#9CA3AF] text-xs mt-0.5">{t('client.changeOrders.pageDesc')}</p>
        </div>

        <ClientChangeOrdersPanel projectId={projectId} />
      </div>
    </ClientLayout>
  );
}
